import styled from 'styled-components';
import getSingleRowStyles from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/styles/index.web';
import getPackshotStyles from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/styles/index.web';
export const PACKSHOT_WIDTH = 248;
export const PACKSHOT_HEIGHT = 139;
export const Container = styled.div `
    display: flex;
    width: 100%;
    height: fit-content;
    align-items: flex-end;
    justify-content: center;

    & .swiper-container {
        overflow: visible;
    }

    & .swiper-slide:hover {
        z-index: 10;
    }
`;
export const PackshotHolder = styled.div `
    transition: transform ease 200ms;
    cursor: pointer;
    &:hover {
        transform: scale(1.1);
    }
`;
export const PackshotImageBorder = styled.div `
    display: ${({ isCurrentlyPlaying }) => (isCurrentlyPlaying ? 'block' : 'none')};
    position: absolute;
    top: 0;
    left: 0;
    border: 2px solid #fabc0b;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    z-index: 1;
`;
export const linearGradientStyle = {
    borderRadius: 8,
    width: '100%',
    height: PACKSHOT_HEIGHT / 2,
    position: 'absolute',
    bottom: 0,
    left: 0,
};
export const getChannelPackshotStyle = (propsTheme) => {
    const packshotStyles = getPackshotStyles(propsTheme);
    return Object.assign(Object.assign({}, packshotStyles), { item: Object.assign(Object.assign({}, packshotStyles.item), { overflow: 'visible' }), packshotHoverLandscape: Object.assign(Object.assign({}, packshotStyles.packshotHoverLandscape), { ':hover': {
                marginTop: 0,
                transform: 'scale(1.04)',
            } }) });
};
export const getChannelsSingleRowStyle = (propsTheme) => {
    const singleRowStyles = getSingleRowStyles(propsTheme);
    return Object.assign(Object.assign({}, singleRowStyles), { container: Object.assign(Object.assign({}, singleRowStyles.container), { width: '99%', overflow: 'visible' }) });
};
//# sourceMappingURL=index.js.map